import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = ["value"];
import { ref, computed, watch, onMounted } from 'vue';
import { mask as vMask } from 'vue-the-mask';
import BaseSelect from '@/components/base-select/base-select.vue';
import countryCodes from './countryCodes.json';
import { getLocalStorageItem } from '@/utils/local-storage';
import { UiInput } from '@huntflow/ui';
export default /*@__PURE__*/ _defineComponent({
    __name: 'phone-input',
    props: {
        id: { default: '' },
        value: { default: '' },
        name: { default: '' },
        hasError: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false }
    },
    emits: ["input", "set-code", "focus"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const tel = ref(null);
        const phoneCode = ref(null);
        const focusInput = ref(true);
        const code = ref('');
        const phoneCodesList = computed(() => {
            return countryCodes.sort((a, b) => a.dial_code.localeCompare(b.dial_code));
        });
        watch(() => __props.hasError, (state) => {
            if (state) {
                focusInput.value = false;
                code.value = '';
            }
        });
        watch(() => __props.hasError, () => {
            tel.value?.focus();
        });
        function selectCode(code) {
            phoneCode.value = code;
            emit('set-code', code);
            tel.value?.focus();
        }
        function onChange(event) {
            emit('input', event);
        }
        onMounted(() => {
            selectCode(getLocalStorageItem('phonecode') || '+7');
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(_ctx.$style.wrapper)
            }, [
                _createVNode(BaseSelect, {
                    class: _normalizeClass(_ctx.$style.select),
                    value: phoneCode.value,
                    onChange: selectCode
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phoneCodesList.value, (codeItem) => {
                            return (_openBlock(), _createElementBlock("option", {
                                key: codeItem.code,
                                value: codeItem.dial_code
                            }, _toDisplayString(codeItem.dial_code), 9, _hoisted_1));
                        }), 128))
                    ]),
                    _: 1
                }, 8, ["class", "value"]),
                _createElementVNode("div", {
                    class: _normalizeClass(_ctx.$style.input)
                }, [
                    _withDirectives(_createVNode(_unref(UiInput), {
                        ref_key: "tel",
                        ref: tel,
                        id: __props.id,
                        type: "tel",
                        disabled: __props.disabled,
                        error: __props.hasError,
                        name: __props.name,
                        autofocus: "",
                        "model-value": __props.value,
                        size: "m",
                        "onUpdate:modelValue": onChange
                    }, null, 8, ["id", "disabled", "error", "name", "model-value"]), [
                        [_unref(vMask), '####################']
                    ])
                ], 2)
            ], 2));
        };
    }
});
